import type {Landmarks,V3} from './rig';

const smooth=(a:number,b:number,x:number)=>{const t=Math.max(0,Math.min(1,(x-a)/(b-a)));return t*t*(3-2*t);};
/** Derived wolf/lynx anatomy shares the authored topology and UVs. No extra download or random fitting drift. */
export function speciesWarp(id:string,lm:Landmarks,p:V3,tail=false):V3 {
  if(id!=='wolf-st'&&id!=='lynx-st')return [...p];
  if(tail){const k=id==='lynx-st'?.30:.82;const root=lm.tail[0];return [root[0]+(p[0]-root[0])*k,root[1]+(p[1]-root[1])*k,root[2]+(p[2]-root[2])*k];}
  const h=smooth(lm.neck[1]-.015,lm.head[1]-.015,p[1]);
  if(h===0)return [...p];
  const cheek=1-smooth(lm.head[1]+.035,lm.headTop[1],p[1]);
  const width=id==='lynx-st'?.24:.22;
  const x=lm.head[0]+(p[0]-lm.head[0])*(1+width*h*cheek);
  const ear=smooth(lm.headTop[1]-.07,lm.headTop[1]+.015,p[1]);
  const y=p[1]+ear*(id==='lynx-st'?.025:-.025);
  const z=p[2]+h*(id==='wolf-st'?.025:.002)*smooth(lm.head[2]+.03,lm.face!.center[2],p[2]);
  return [x,y,z];
}
export function speciesLandmarks(id:string,source:Landmarks):Landmarks {
  if(id!=='wolf-st'&&id!=='lynx-st')return source;
  const lm=structuredClone(source);
  for(const key of Object.keys(lm) as Array<keyof Landmarks>){
    if(key==='radius'||key==='face')continue;
    const value=lm[key];
    if(!value)continue;
    if(Array.isArray(value[0]))(lm as unknown as Record<string,V3[]>)[key]=(value as V3[]).map(v=>speciesWarp(id,source,v,key==='tail'));
    else (lm as unknown as Record<string,V3>)[key]=speciesWarp(id,source,value as V3);
  }
  lm.radius.head*=1.16;
  if(lm.face)lm.face={center:speciesWarp(id,source,lm.face.center),scale:lm.face.scale*1.07};
  return lm;
}
